// const Index = () => import('./views/index')

const routes = []

export default routes
